// extracted by mini-css-extract-plugin
export default {"root":"PhotoDetail_root__RU+LX","photo":"PhotoDetail_photo__Y4egb"};